// extracted by mini-css-extract-plugin
module.exports = {"temporary_responsive_section_spacing":"styles_temporary_responsive_section_spacing__m_NSm"};